export enum ModeType {
    PANEU = 'paneu',
    REGIONAL = 'regional',
    COUNTRY = 'country',
}
